import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Leftbar from "../../components/Leftsidebar";
import Topbar from "../../components/Topbar";
import { Link } from "react-router-dom";
import "../Projects/project.css";
import { getResources, deleteResource, getCategoryDropdown, markResourceHero, showToast, usTimezone } from "../Utils/utils";
import ReactPaginate from 'react-paginate';
import { Col, Row } from 'react-bootstrap';
import Loaderspinner from "../../components/Loader";
import { Tooltip } from 'react-tooltip'
import SweetAlert from "react-bootstrap-sweetalert";

const Resources = () => {
    const navigate = useNavigate();

    const [showSidebar, setShowSidebar] = useState(false);
    const [loading, setLoading] = useState(false)
    const [resourceList, setResourceList] = useState([]);
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [search, setSearch] = useState("");
    const [resourceId, setResourceId] = useState(null);
    const [showAlert, setShowAlert] = useState(false);
    const [showHero, setShowHero] = useState(false);
    const [categoriesList, setCategoriesList] = useState([])

    const openAnalytics = (referenceId, type, event) => {
        navigate("/analytics-detail", {
            state: {
                reference_id: referenceId,
                type,
                event
            }
        });
    };

    const handleSidebar = () => {
        setShowSidebar(!showSidebar);
    };

    const handleSidebarClose = () => {
        setShowSidebar(false);
    };

    useEffect(() => {
        if (search.length == 0 || search.length >= 3) {
            fetchList();
        }
    }, [page, search]);

    useEffect(() => {
        fetchCategories()
    }, []);

    const fetchCategories = async () => {
        try {
            const response = await getCategoryDropdown();

            if (response?.status == 200) {
                setCategoriesList(response?.data);
            } else {
                console.log("cannot fetch categories", response)
            }

        } catch (error) {
            console.error(error);
        }
    };

    const fetchList = async () => {
        try {
            setLoading(true);
            const limit = 10;
            const offset = page * limit;

            const response = await getResources({ search, limit, offset });

            if (response?.status == 200) {
                setResourceList(response?.data?.rows);
                if ((response?.data?.count || 0) < limit) {
                    setTotalPages(page + 1);
                } else {
                    setTotalPages(page + 2);
                }
            } else {
                console.log("cannot fetch resources", response)
            }

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async () => {
        var res = await deleteResource(resourceId)
        if (res.status == 200) {
            showToast("Deleted successfully", "success");
            fetchList();
        }
        setShowAlert(false);
    };
    const handleHero = async () => {
        var res = await markResourceHero({ resource_id: resourceId })
        if (res.status == 200) {
            showToast("Resource updated successfully", "success");
            fetchList();
        }
        setShowHero(false);
    };

    return (
        <>
            {loading && <Loaderspinner />}
            <div class="g-sidenav-show  bg-gray-100">
                <div id="wrapper">
                    <Leftbar showSidebar={showSidebar}
                        handleSidebarClose={handleSidebarClose} />
                    <main className="main-content border-radius-lg">
                        <Topbar handleSidebar={handleSidebar} />

                        <div className="header header-bg pb-6">
                            <div className="container-fluid">
                                <div className="header-body">
                                    <div className="row align-items-center py-4">
                                        <div className="col-lg-6 col-7">
                                            <nav
                                                aria-label="breadcrumb"
                                                className="d-none d-md-inline-block ml-md-4"
                                            >
                                                <ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
                                                    <li className="breadcrumb-item">
                                                        <Link to="/dashboard">
                                                            <i className="fas fa-home" />
                                                        </Link>
                                                    </li>
                                                    <li className="breadcrumb-item mt-2">
                                                        <span className="" style={{ color: "#f6f9fc" }}>Resources</span>
                                                    </li>
                                                </ol>
                                            </nav>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container-fluid mt--6">
                            <div className="row">
                                <div className="col">
                                    <div className="card">
                                        <div className="card-header border-0">
                                            <div className="d-flex justify-content-between">
                                                <div className="row ">
                                                    <h5 className="mb-0 w-auto">Resources</h5>
                                                    <p
                                                        className="w-auto px-0"
                                                        data-tooltip-id="my-tooltip"
                                                        data-tooltip-content="A complete list of all resources available on the platform. Use this section to review resource details, manage visibility, track engagement metrics, and ensure content accuracy."
                                                        data-tooltip-place="right"
                                                    >
                                                        <i className="fas fa-info-circle" />

                                                    </p>

                                                    <Tooltip id="my-tooltip" style={{ width: '30%' }} />
                                                </div>
                                                <div className="d-flex align-items-center">
                                                    <input
                                                        type="text"
                                                        className="search-input mx-2"
                                                        placeholder="Search"
                                                        value={search}
                                                        onChange={(e) => setSearch(e.target.value)}
                                                    />
                                                    <Link to="/add-resource">
                                                        <button className="export-btn"> Create Resource </button>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="table-responsive">
                                            <table className="table align-items-center table-flush">
                                                <thead className="thead-light">
                                                    <tr>
                                                        <th>Name</th>
                                                        <th>Category</th>
                                                        <th>Hero</th>
                                                        <th>Views</th>
                                                        <th>Created At</th>
                                                        <th>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {resourceList?.length > 0 ? (
                                                        resourceList.map((resource, index) => (
                                                            <tr key={index}>
                                                                <td style={{ width: "250px" }}>{resource?.title}</td>
                                                                <td>
                                                                    {
                                                                        categoriesList?.find(cat => cat.id === resource.category_id)?.name
                                                                        || "None"
                                                                    }
                                                                </td>
                                                                <td>{resource?.is_hero ? "Yes" : "No"}</td>
                                                                <td>
                                                                    <button className="viewproject-btn pull-right" style={{ width: "fit-content" }} onClick={() => openAnalytics(resource?.id, "resource", "view")}>
                                                                        {resource?.views_count || 0}
                                                                    </button>
                                                                </td>
                                                                <td>{usTimezone(resource?.created_at)}</td>
                                                                <td style={{ width: "160px" }}>
                                                                    <Link to={`/edit-resource/${resource?.id}`}>
                                                                        <button className="viewproject-btn pull-right mb-1" >
                                                                            <span className="text-white">Edit Resource</span>
                                                                        </button>
                                                                    </Link>
                                                                    <Link to={`/manage-resource/${resource?.id}`}>
                                                                        <button className="viewproject-btn pull-right mb-1" >
                                                                            <span className="text-white">Manage Content</span>
                                                                        </button>
                                                                    </Link>
                                                                    <button className="viewproject-btn pull-right mb-1" onClick={() => {
                                                                        setResourceId(resource?.id)
                                                                        setShowAlert(true)
                                                                    }} >
                                                                        <span className="text-white">Delete</span>
                                                                    </button>
                                                                    {!resource?.is_hero &&
                                                                        <button className="viewproject-btn pull-right mb-1" onClick={() => {
                                                                            setResourceId(resource?.id)
                                                                            setShowHero(true)
                                                                        }} >
                                                                            <span className="text-white">Mark as Hero</span>
                                                                        </button>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        ))) :
                                                        <tr>
                                                            <td colSpan="10" className="text-center"><b>No records found</b></td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Row>
                                <Col xs={12}>
                                    <div className='paginate-css'>
                                        <ReactPaginate
                                            previousLabel="<"
                                            nextLabel=">"
                                            breakLabel="..."
                                            pageCount={totalPages}
                                            marginPagesDisplayed={1}
                                            pageRangeDisplayed={2}
                                            onPageChange={({ selected }) => setPage(selected)}
                                            containerClassName="pagination"
                                            activeClassName="active"
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </main>
                    {showAlert && (
                        <SweetAlert
                            warning
                            showCancel
                            confirmBtnText="Yes, delete it!"
                            confirmBtnBsStyle="danger"
                            cancelBtnBsStyle="secondary"
                            title="Are you sure?"
                            onConfirm={handleDelete}
                            onCancel={() => setShowAlert(false)}
                            focusCancelBtn
                        >
                            This action cannot be undone.
                        </SweetAlert>
                    )}
                    {showHero && (
                        <SweetAlert
                            warning
                            showCancel
                            confirmBtnText="Yes"
                            confirmBtnBsStyle="danger"
                            cancelBtnBsStyle="secondary"
                            title="This will replace the current hero resource with this one."
                            onConfirm={handleHero}
                            onCancel={() => setShowHero(false)}
                            focusCancelBtn
                        >
                        </SweetAlert>
                    )}
                </div>
            </div>
        </>

    )
}
export default Resources;